import React, { useRef, useEffect } from "react";

// Background digit-rain canvas. Relocated verbatim from the public/index.html IIFE
// so React owns BOTH the canvas node and the animation loop (ends the split-ownership
// blank-on-load bug). Pure structural move — constants, init(), and draw() are
// byte-for-byte identical to the original; only ownership/teardown changed.
function RainCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const FONT_SIZE  = 15;
    const CHARS      = '0123456789';
    const TRAIL      = 14;
    const MAX_ALPHA  = 0.16;
    const HEAD_ALPHA = 0.22;
    const FADE       = 0.22;

    const PALETTE = [
      { r: 129, g: 140, b: 248 },
      { r: 129, g: 140, b: 248 },
      { r: 129, g: 140, b: 248 },
      { r: 167, g: 139, b: 250 },
      { r:  99, g: 102, b: 241 },
      { r:  56, g: 189, b: 248 },
      { r: 249, g: 115, b:  22 },
    ];

    let cols, drops, dropSpeeds, dropColors;

    function init() {
      canvas.width  = window.innerWidth;
      canvas.height = window.innerHeight;
      cols       = Math.floor(canvas.width / (FONT_SIZE + 8));
      drops      = Array.from({ length: cols }, () =>
                     Math.random() * -(canvas.height / FONT_SIZE) * 1.5);
      dropSpeeds = Array.from({ length: cols }, () =>
                     0.15 + Math.random() * 0.38);
      dropColors = Array.from({ length: cols }, () =>
                     PALETTE[Math.floor(Math.random() * PALETTE.length)]);
    }

    function draw() {
      if (!canvas.width || !canvas.height) return;
      ctx.fillStyle = 'rgba(15,16,20,' + FADE + ')';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      for (var i = 0; i < cols; i++) {
        var x   = i * (FONT_SIZE + 8) + 4;
        var col = dropColors[i];

        for (var t = 0; t < TRAIL; t++) {
          var charY = (Math.floor(drops[i]) - t) * FONT_SIZE;
          if (charY < -FONT_SIZE || charY > canvas.height) continue;
          var ch = CHARS[Math.floor(Math.random() * CHARS.length)];

          if (t === 0) {
            ctx.font      = 'bold ' + (FONT_SIZE + 1) + 'px "Courier New",monospace';
            ctx.fillStyle = 'rgba(255,255,255,' + HEAD_ALPHA + ')';
          } else {
            var alpha = Math.max(0.008, MAX_ALPHA - t * 0.004);
            ctx.font      = FONT_SIZE + 'px "Courier New",monospace';
            ctx.fillStyle = 'rgba(' + col.r + ',' + col.g + ',' +
                            col.b + ',' + alpha + ')';
          }
          ctx.fillText(ch, x, charY);
        }

        drops[i] += dropSpeeds[i];

        if (drops[i] * FONT_SIZE > canvas.height + TRAIL * FONT_SIZE) {
          if (Math.random() > 0.94) {
            drops[i]      = Math.random() * -20;
            dropSpeeds[i] = 0.15 + Math.random() * 0.38;
            dropColors[i] = PALETTE[Math.floor(Math.random() * PALETTE.length)];
          }
        }
      }
    }

    init();
    const intervalId = setInterval(draw, 38);
    window.addEventListener("resize", init);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("resize", init);
    };
  }, []);

  return <canvas id="bg-rain" ref={canvasRef} />;
}

export default RainCanvas;
